<template>
  <div class="stickyCss">
    <div class="chk_m">
      <div class="all">
        <ul>
          <li>
            <input
              type="radio"
              id="chk_m0101"
              name="allrdo"
              v-model="$store.state.usRecordSettings.chkIndex"
              value="ALL"
              @click="saveUsChkIndexChgSettings"
              @change="scrollToPosition"
            />
            <label for="chk_m0101">전체</label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_m0102"
              name="allrdo"
              v-model="$store.state.usRecordSettings.chkIndex"
              value="DOW"
              @change="scrollToPosition"
            />
            <label for="chk_m0102">다우30</label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_m0103"
              name="allrdo"
              v-model="$store.state.usRecordSettings.chkIndex"
              value="NDX"
              @change="scrollToPosition"
            />
            <label for="chk_m0103">나스닥100</label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_m0104"
              name="allrdo"
              v-model="$store.state.usRecordSettings.chkIndex"
              value="SP"
              @change="scrollToPosition"
            />
            <label for="chk_m0104">S&P500</label>
          </li>
        </ul>
      </div>
      <!-- //모아보기 -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    saveUsChkIndexChgSettings () {
      this.$store.dispatch('saveUsChkIndexChgSettings', true)
    },
    scrollToPosition () {
      this.$store.dispatch('saveUsChkIndexChgSettings', true)
      if (window.scrollY >= 141) {
        window.scrollTo({
          top: 141
        })
      }
    }
  }
}
</script>

<style scoped>
.stickyCss {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 999;
  width: 100%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/mb/common/WhrSearch.vue